import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import TenantScopedLayout from "./components/tenant/TenantScopedLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import ContactPage from "./pages/ContactPage";
import AppointmentPage from "./pages/AppointmentPage";
import CursosPage from "./pages/CursosPage";
import EventsPage from "./pages/EventsPage";
import LoginPage from "./pages/auth/LoginPage";
import EmailLinkLoginPage from "./pages/auth/EmailLinkLoginPage";
import CompleteLoginPage from "./pages/auth/CompleteLoginPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ClientSelectionPage from "./pages/auth/ClientSelectionPage";
import PatientDashboard from "./pages/patient/PatientDashboard";
import DoctorDashboard from "./pages/doctor/DoctorDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import FisioterapeutaDashboard from "./pages/fisioterapeuta/FisioterapeutaDashboard";
import SuperAdminDashboard from "./pages/super-admin/SuperAdminDashboard";
import NotFoundPage from "./pages/NotFoundPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import AuthGuard from "./components/auth/AuthGuard";
import { AuthProvider } from "./context/AuthContext";
import NewFinancialDashboard from "./pages/admin/NewFinancialDashboard";
import RLSTestPage from "./pages/RLSTestPage";
import PublicAssessmentInvitePage from "./pages/PublicAssessmentInvitePage";
import PublicPeakFlowDiaryPage from "./pages/PublicPeakFlowDiaryPage";
import PublicDocumentVerificationPage from "./pages/PublicDocumentVerificationPage";
import WhatsNewExperience from "./components/common/WhatsNewExperience";
import FinancialA2RpcTestPage from "./pages/admin/FinancialA2RpcTestPage";
import FinancialA3RpcTestPage from "./pages/admin/FinancialA3RpcTestPage";

const renderSharedRoutes = () => (
  <>
    <Route index element={<HomePage />} />
    <Route path="sobre" element={<AboutPage />} />
    <Route path="servicos" element={<ServicesPage />} />
    <Route path="noticias" element={<NewsPage />} />
    <Route path="noticias/:id" element={<NewsDetailPage />} />
    <Route path="contato" element={<ContactPage />} />
    <Route path="agendar" element={<AppointmentPage />} />
    <Route path="cursos" element={<CursosPage />} />
    <Route path="eventos" element={<EventsPage />} />
    <Route path="acesso-negado" element={<AccessDeniedPage />} />

    <Route
      path="login"
      element={
        <AuthGuard requireAuth={false}>
          <LoginPage />
        </AuthGuard>
      }
    />
    <Route
      path="login/email"
      element={
        <AuthGuard requireAuth={false}>
          <EmailLinkLoginPage />
        </AuthGuard>
      }
    />
    <Route
      path="login/complete"
      element={
        <AuthGuard requireAuth={false}>
          <CompleteLoginPage />
        </AuthGuard>
      }
    />
    <Route
      path="recuperar-senha"
      element={
        <AuthGuard requireAuth={false}>
          <ForgotPasswordPage />
        </AuthGuard>
      }
    />
    <Route
      path="redefinir-senha"
      element={
        <AuthGuard requireAuth={false}>
          <ResetPasswordPage />
        </AuthGuard>
      }
    />
    <Route
      path="cadastro"
      element={
        <AuthGuard requireAuth={false}>
          <RegisterPage />
        </AuthGuard>
      }
    />
    <Route
      path="selecionar-cliente"
      element={
        <AuthGuard requireAuth requireClientSelected={false}>
          <ClientSelectionPage />
        </AuthGuard>
      }
    />
    <Route
      path="teste"
      element={
        <AuthGuard requireAuth requireClientSelected={false}>
          <RLSTestPage />
        </AuthGuard>
      }
    />
    <Route
      path="patient/*"
      element={
        <AuthGuard allowedRoles={["patient"]}>
          <PatientDashboard />
        </AuthGuard>
      }
    />
    <Route
      path="doctor/*"
      element={
        <AuthGuard allowedRoles={["doctor"]}>
          <DoctorDashboard />
        </AuthGuard>
      }
    />
    <Route
      path="admin/*"
      element={
        <AuthGuard allowedRoles={["admin", "interno"]}>
          <AdminDashboard />
        </AuthGuard>
      }
    >
      <Route path="financial-new" element={<NewFinancialDashboard />} />
    </Route>
    <Route
      path="admin-a2-rpc-test"
      element={
        <AuthGuard allowedRoles={["admin", "interno", "financeiro"]}>
          <FinancialA2RpcTestPage />
        </AuthGuard>
      }
    />
    <Route
      path="admin-a3-rpc-test"
      element={
        <AuthGuard allowedRoles={["admin", "interno"]}>
          <FinancialA3RpcTestPage />
        </AuthGuard>
      }
    />
    <Route
      path="fisioterapeuta/*"
      element={
        <AuthGuard allowedRoles={["fisioterapeuta"]}>
          <FisioterapeutaDashboard />
        </AuthGuard>
      }
    />
    <Route
      path="super-admin"
      element={
        <AuthGuard allowedRoles={["superAdmin"]} requireClientSelected={false}>
          <SuperAdminDashboard />
        </AuthGuard>
      }
    />
    <Route path="*" element={<NotFoundPage />} />
  </>
);

function App() {
  return (
    <AuthProvider>
      <WhatsNewExperience />
      <Routes>
        <Route path="/:tenantSlug/q/:token" element={<PublicAssessmentInvitePage />} />
        <Route path="/:tenantSlug/monitoramento/peakflow/:token" element={<PublicPeakFlowDiaryPage />} />
        <Route path="/verificar/:token" element={<PublicDocumentVerificationPage />} />
        <Route path="/:tenantSlug/verificar/:token" element={<PublicDocumentVerificationPage />} />

        <Route path="/" element={<Layout />}>
          {renderSharedRoutes()}
        </Route>

        <Route path="/:tenantSlug" element={<TenantScopedLayout />}>
          {renderSharedRoutes()}
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
